export default __webpack_public_path__ + "static/media/female_stomach.911cd00e.png";